module.exports = __webpack_public_path__ + "static/media/Poster.5f1fc6b4.pdf";